// extracted by mini-css-extract-plugin
module.exports = {"section":"QI2_section__59jSg"};